import { CSSObject } from '@chakra-ui/react';

export const FlexPageWrapper: CSSObject = {
  px: '5',
  pb: '3',
  mt: '1',
};
